module.exports = __webpack_public_path__ + "img/5.ba645ddb.png";